import { render, staticRenderFns } from "./ChecklistStringFieldModule.vue?vue&type=template&id=3096aeec&scoped=true"
import script from "./ChecklistStringFieldModule.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChecklistStringFieldModule.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ChecklistStringFieldModule.vue?vue&type=style&index=0&id=3096aeec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3096aeec",
  null
  
)

export default component.exports